<template>
    <div>
        <div class="custom-splash" v-show="animate === true">
            <div id="splash_cont" class="animate">
                <svg height="400" width="400" xmlns="http://www.w3.org/2000/svg">
                    <circle class="circle" cx="200" cy="200" r="195"></circle>
                </svg>
                <img id="ruby" src="img/sre_vert.svg" alt="" width="50%"/>
                <h2 id="splash_title">
                    <br>
                    SIPAC27 {{ version }}
                </h2>
            </div>
        </div>

        <span v-if="userInfo.isApproved">
            <el-container>
                <el-header style="background-color: #13322B">
                    <el-row type="flex" justify="space-between">
                        <el-col :span="8">
                            <el-menu
                                mode="horizontal"
                                background-color="#13322B"
                                text-color="#fff"
                                active-text-color="#fff"
                                style="background-color: transparent">
                                <el-menu-item  @click="goToPanel">
                                 <img src="/img/login/logo_sre.png" style="width: 5em">
                                </el-menu-item>
                                <el-menu-item
                                    disabled
                                    style="opacity: 1 !important; font-size: 1.35em !important">
                                     SIPAC27 <small>{{ version }}</small>
                                </el-menu-item>
                            </el-menu>
                        </el-col>

                        <el-col :span="16" align="right">
                            <el-menu
                                mode="horizontal"
                                background-color="#13322B"
                                text-color="#fff"
                                active-text-color="#fff"
                                style="background-color: transparent; float:right;"
                            >
                                <el-menu-item
                                    index="/"
                                    class="border-menu-item">
                                    <i style="color: #ffffff !important;" class="fas fa-home"></i>
                                </el-menu-item>
                                <el-menu-item
                                    index="/perfil"
                                    class="border-menu-item">
                                    <i style="color: #ffffff !important;"
                                       class="fas fa-user"></i> {{ userFullName | truncateCustom(25) }}
                                </el-menu-item>
                                <el-menu-item
                                    index="#"
                                    @click="logOut"
                                    class="border-menu-item">
                                    <i style="color: #ffffff !important;" class="fas fa-sign-out-alt"></i>
                                    Cerrar sesión
                                </el-menu-item>
                            </el-menu>
                        </el-col>
                    </el-row>
                </el-header>
                <el-container>
                    <el-main class="content-wrapper">
                        <router-view></router-view>
                    </el-main>
                </el-container>
            </el-container>
        </span>
        <span v-if="!userInfo.isApproved && !userInfo.isMigrate">
            <div class="tip">
                Esta cuenta está siendo validada por la administración de la aplicación. <br>
                Para cualquier duda o comentario favor de contactar a articulo27@sre.gob.mx
            </div>
            <br>

            <el-button
                @click="logOut"
                type="danger">
                <i style="color: #ffffff !important;" class="fas fa-sign-out-alt"></i>
                Cerrar sesión
            </el-button>
        </span>

        <span v-if="showUpdate">
        <el-dialog
            :fullscreen="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            title="Actualización de Información"
            :show-close="false"
            class="validate-dialog"
            :visible.sync="showUpdate">
        <el-row>
            <div class="tip" style="font-size: 10pt !important;">
                <p style="text-align: center !important;">
                    ¡{{ userFullName }} le damos la Bienvenida al Nuevo Sistema Integral para Artículo 27
                    Constitucional!
                    <br>
                    <b style="font-weight: bold !important;">SIPAC27</b>
                </p>
                <br>
                Por motivos de seguridad, es necesario actualizar algunos rubros en su información personal
                <br>

            </div>
        </el-row>
        <Profile :update-info="true"></Profile>
        <br>
    </el-dialog>
   </span>


    </div>
</template>


<script>
import {mapGetters} from 'vuex';
import password from 'vue-password-strength-meter';
import Profile from "../../partials/Profile";

export default {

    components: {
        password,
        Profile
    },

    data() {
        return {
            animate: false,
            isCollapse: true,
            icon: 'fas fa-angle-right',
            sideMenuText: 'Mostrar menú',
            rIcon: 'fas fa-file-excel',
            rText: 'Reportes',
            iConsult: 'fas fa-search',
            cText: 'Búsqueda',
            version: '',
            showUpdate: false,
            userForm: {},
            userConfirmed: false,
            loading: false,
            profiles: [],
            offices: [],
            prefixes: [],
            banks: [],
            notaries: [],

        };
    },
    computed: {
        userInfo() {
            return this.$store.state.user.user;
        },
        ...mapGetters(['userFullName']),
        ...mapGetters('loading', ['message', 'status']),
    },
    created() {
        this.version = window.versionApp;
        if (this.$store.state.user && this.$store.state.user?.user?.cat_profile_id >= 4) {
            window.location.replace("/solicitudes");
        } else {
            if (this.userInfo?.isMigrate) {
                this.showUpdate = true;
            }
            /* axios.get('/api/my-profile').then(response => {
                 if(response.data.success){
                     this.profiles = response.data.profiles;
                     this.offices = response.data.offices;
                     this.prefixes = response.data.prefixes;
                     this.banks = response.data.banks;
                     this.notaries = response.data.notaries;
                 }else{
                     this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});

                 }
             });*/
            this.init();
        }

    },
    methods: {


        credentialsValidate(username, password) {

            if (username && password) {
                let _params = {
                    username: username,
                    password: password
                };
                this.loading = true;
                axios.post('/api/validate-credentials', _params).then(response => {
                    if (response.data.success) {
                        this.userConfirmed = true;
                        this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                        this.userForm.name = response.data.user.name;
                        this.userForm.firstName = response.data.user.firstName;
                        this.userForm.secondName = response.data.user.secondName;
                        this.userForm.email = response.data.user.email;
                        this.loading = false;
                    }
                })
            }

        },

        init() {
            if (!window.localStorage.getItem('sipac_splash')) {
                this.animate = true;
                setTimeout(() => {
                    this.animate = false;
                    if (this.userInfo && this.userInfo.isMigrate) {
                        this.showUpdate = true;
                    }
                }, 3000);
                window.localStorage.setItem('sipac_splash', 1);


            }
        },
        goToPanel() {
            this.$router.push('/');
        },

        logOut: function () {

            this.$confirm('¿Desea cerrar su sesión? Antes asegúrese de guardar todos sus cambios.', 'Alerta', {
                confirmButtonText: 'Cerrar Sesión',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(() => {
                let _this = this;

                _this.$store.dispatch(
                    'loading/spinner', {msg: 'Conectando...', status: true}, {root: true});
                let _params = {
                    id: this.userInfo.id
                }
                axios.post('/api/logout', _params).then(response => {
                    _this.$store.dispatch('loading/spinner', {}, {root: true});

                    if (response.data.authenticated === false) {

                        sessionStorage.removeItem('sipac_token');
                        sessionStorage.removeItem('sipac_token_expiration');
                        sessionStorage.removeItem('sipac_user');

                        axios.defaults.headers.common = {
                            'Authorization': 'Bearer'
                        };

                        _this.deleteUser();
                        setTimeout(() => {
                            _this.$router.push('/login');
                            location.reload()

                        }, 300);

                    } else {
                        _this.$message({
                            type: 'warning',
                            message: 'No fue posible cerrar su sesión, inténtelo nuevamente.'
                        });
                    }
                }).catch(error => {
                    _this.$store.dispatch('loading/spinner', {}, {root: true});

                    _this.$message({
                        type: 'warning',
                        message: 'No fue posible conectarse al servidor.'
                    });
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Cancelado'
                });
            });

        },

        updateConfirm() {

        },

        showAsideMenu() {
            if (this.isCollapse === true) {

                this.isCollapse = false;
                this.icon = 'fas fa-angle-left';
                this.sideMenuText = 'Ocultar menú';

            } else {

                this.isCollapse = true;
                this.icon = 'fas fa-angle-right';
                this.sideMenuText = 'Mostrar menú';
            }
        },

        deleteUser() {
            this.$store.commit('deleteUser');
        }
    }
}

</script>

<style>
/* Header with menu */
.el-header {
    background-color: #0C231E;
    border-bottom: 4px solid rgb(212, 193, 156);
    color: #FFF;
    line-height: 60px;
}

.logo-sre {
    background: url(/img/login/logo_sre.png) no-repeat;
    background-size: contain;
    height: 45px;
    width: 200px;
    overflow: hidden;
    margin-top: 10px;
    margin-left: 5px;
}

.logo-sicre:hover {
    cursor: pointer;
    opacity: 0.75;
}

.input-search > div input {
    background: #5B6573;
    border: none;
    color: #FFF;
}

.header-menu {
    margin-right: -20px
}

.border-menu-item {
    border-bottom: 4px solid rgb(212, 193, 156) !important;
}

.border-menu-item:hover {
    background-color: #0C231E !important;
    border-bottom: 4px solid rgb(212, 193, 156) !important;
    opacity: 0.75 !important;
}

.el-badge__content.is-fixed.is-dot {
    top: 24px;
}

/*.el-menu-item.border-menu-item.is-active {*/
/*border-bottom: 4px solid #DB2828 !important;*/
/*}*/

.el-dropdown-menu.el-popper {
    text-align: right
}

/* Content */
.el-container {
    height: 640px;
}

/* Side menu */
.el-aside {
    height: 100%
}

.el-menu {
    border: none;
}

.el-menu-vertical:not(.el-menu--collapse) {
    width: 225px;
}

.el-aside-menu-icon {
    vertical-align: middle;
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 18px;
}

/* Content wrapper */
.content-wrapper {
    /*border: 16px solid #E9EEF3;*/
    /*background-color: #FFF;*/

    height: 100%;
    background-image: url(/img/sre_white.png);

    background-repeat: no-repeat;
    background-size: cover;
    width: 100% !important;
}

@media screen and ( min-height: 768px ) {
    /* Content */
    .el-container {
        height: 768px
    }
}

@media screen and ( min-height: 896px ) {
    /* Content */
    .el-container {
        height: 896px
    }
}

@media screen and ( min-height: 912px ) {
    /* Content */
    .el-container {
        height: 912px
    }
}

@media screen and ( min-height: 1024px ) {
    /* Content */
    .el-container {
        height: 1024px
    }
}

@media screen and ( min-height: 1090px ) {
    /* Content */
    .el-container {
        height: 1090px
    }
}

@media screen and ( min-height: 1100px ) {
    /* Content */
    .el-container {
        height: 1100px
    }
}

@media screen and ( min-height: 1180px ) {
    /* Content */
    .el-container {
        height: 1180px
    }
}

@media screen and ( min-height: 1220px ) {
    /* Content */
    .el-container {
        height: 1220px
    }
}

@media screen and ( min-height: 1280px ) {
    /* Content */
    .el-container {
        height: 1280px
    }
}

@media screen and ( min-height: 1312px ) {
    /* Content */
    .el-container {
        height: 1312px
    }
}

@media screen and ( min-height: 1412px ) {
    /* Content */
    .el-container {
        height: 1412px
    }
}

@media screen and ( min-height: 1524px ) {
    /* Content */
    .el-container {
        height: 1524px
    }
}

/*
        animate
 */

/* BEST RESULTS ON WEBKIT BROWSER */

.blur {
    background: #fff;
    -webkit-filter: blur(5px);
    -moz-filter: blur(5px);
    -o-filter: blur(5px);
    -ms-filter: blur(5px);
    filter: blur(5px);
}

.custom-splash {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    z-index: 9999;

}

#splash_cont {
    background: rgba(255, 255, 255, 0.52);
    position: relative;
    z-index: 9999999;
}

#splash_cont.animate {

    height: 400px;
    width: 400px;
    position: relative;
    border-radius: 50%;
    margin: 0 auto;
    top: 45%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    -webkit-animation: move-ruby 0.7s ease 2.4s forwards;
    animation: move-ruby 0.7s ease 2.4s forwards;
}

#splash_cont.animate #ruby {
    position: absolute;
    top: 125px;
    left: 64.5px;
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-animation: scale-ruby 0.48s ease 0s forwards;
    animation: scale-ruby 0.48s ease 0s forwards;
}

#splash_cont.animate .circle {
    fill: rgba(254, 82, 79, 0);
    stroke: rgba(254, 82, 79, 0);
    stroke-width: 4;
    stroke-dasharray: 1228;
    stroke-dashoffset: 0;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
    -webkit-animation: animate-ruby-circle 1.3s ease 0.3s forwards;
    animation: animate-ruby-circle 1.3s ease 0.3s forwards;
}

#splash_cont.animate #splash_title {
    text-align: center;
    font-weight: 500;
    font-size: 15pt !important;
    color: rgba(80, 80, 80, 0);
    -webkit-animation: splash_title 1.2s ease 1.2s forwards;
    animation: splash_title 1.2s ease 1.2s forwards;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    -webkit-transform: translateY(150%);
    transform: translateY(150%);
}

@-webkit-keyframes scale-ruby {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0);
        top: 125px;
    }
    60% {
        -webkit-transform: scale(1.25);
        transform: scale(1.25);
        top: 120px;
    }
    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
        top: 125px;
    }
}

@keyframes scale-ruby {
    0% {
        -webkit-transform: scale(0);
        transform: scale(0);
        top: 125px;
    }
    60% {
        -webkit-transform: scale(1.25);
        transform: scale(1.25);
        top: 120px;
    }
    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
        top: 125px;
    }
}

@-webkit-keyframes animate-ruby-circle {
    0% {
        stroke-dashoffset: 1228;
        stroke: #dfcdb2;
    }
    70% {
        stroke: #c9af8d;
        stroke-width: 4;
    }
    90% {
        stroke-dashoffset: 0;
    }
    100% {
        stroke-dashoffset: 0;
        stroke: #dec4a1;
        stroke-width: 10;
    }
}

@keyframes animate-ruby-circle {
    0% {
        stroke-dashoffset: 1228;
        stroke: #dfcdb2;
    }
    70% {
        stroke: #c9af8d;
        stroke-width: 4;
    }
    90% {
        stroke-dashoffset: 0;
    }
    100% {
        stroke-dashoffset: 0;
        stroke: #dec4a1;
        stroke-width: 10;
    }
}

@-webkit-keyframes splash_title {
    0% {
        color: rgba(80, 80, 80, 0);
    }
    18% {
        color: #505050;
    }
    65% {
        color: #505050;
    }
    100% {
        color: rgba(80, 80, 80, 0);
    }
}

@keyframes splash_title {
    0% {
        color: rgba(80, 80, 80, 0);
    }
    18% {
        color: #505050;
    }
    65% {
        color: #505050;
    }
    100% {
        color: rgba(80, 80, 80, 0);
    }
}

@-webkit-keyframes move-ruby {
    0% {
        opacity: 1;
        top: 45%;
        -webkit-transform: scale(1) translateY(-50%);
        transform: scale(1) translateY(-50%);
    }
    20% {
        opacity: 1;
    }
    100% {
        opacity: 0;
        top: 35%;
        -webkit-transform: scale(0.01) translateY(-280%);
        transform: scale(0.01) translateY(-280%);
    }
}

@keyframes move-ruby {
    0% {
        opacity: 1;
        top: 45%;
        -webkit-transform: scale(1) translateY(-50%);
        transform: scale(1) translateY(-50%);
    }
    20% {
        opacity: 1;
    }
    100% {
        opacity: 0;
        top: 35%;
        -webkit-transform: scale(0.01) translateY(-280%);
        transform: scale(0.01) translateY(-280%);
    }
}
</style>
